import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useHistory } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountCircle from "@material-ui/icons/AccountCircle";
import axios from "../../axios-order";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink } from "react-router-dom";
import cws_logo from "../../asserts/images/Logo without text.png";
import "./layout.css";
import { toast } from "react-toastify";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import Modal from "react-bootstrap/Modal";
import MuiTreeView from "material-ui-treeview";
import Button from "@material-ui/core/Button";
import PanDashBoard from "./PanDashBoard/PanRouter";
import BusinessIcon from "@material-ui/icons/Business";
import NoteIcon from "@material-ui/icons/Note";
import IosShareIcon from '@mui/icons-material/IosShare';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HandshakeIcon from '@mui/icons-material/Handshake';
import WorkIcon from '@mui/icons-material/Work';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import DescriptionIcon from '@mui/icons-material/Description';
import TaskIcon from '@mui/icons-material/Task';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CircularProgress from "@material-ui/core/CircularProgress";

const drawerWidth = 86.5;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    fontFamily: "Dosis",
    overflowX: 'auto',

  },
  primary: {
    fontFamily: "Dosis",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaper: {
    width: drawerWidth,
    background: "var(--sidebar-bg)",
  },
  drawerHeader: {
    width: drawerWidth,
    backgroundColor: "var(--sidebar-bg)",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  drawerHeaderSpace: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(7, 0),
    // background: "#fafafa",

    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  listStyle: {
    overflowY: "auto",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  logoBox: {
    width: "100%",
    height: 90,
    paddingTop: 31,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // backgroundColor:'#FFFFFF'
    // padding: theme.spacing(1),
    // borderBottom: "1px solid #444",
  },
  logo: {
    width: "65%",
    height: "auto",
    cursor: "pointer",
    // backgroundColor:'#FFFFFF'
  },
  list: {
    width: "100%",
    paddingTop: theme.spacing(1),
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1),
    color: "var(--app-bar-bg)",
    textDecoration: "none",
    fontWeight: 500,
    fontFamily: "Dosis",
    fontSize: "11px",
    "&:hover": {
      // backgroundColor: "var(--app-bar-bg)",
      color: "#FFFFFF !important",
      fontWeight: 600,
    },
  },
  listItemIcon: {
    color: "var(--app-bar-bg)",
    justifyContent: "center",
    // minWidth: "auto",
    // fontSize: "3rem",
  },
  listItemText: {
    fontFamily: "'Arial', sans-serif",
    margin: 0,
    fontSize: "11px",
    color: "var(--app-bar-bg)",
    textAlign: "center",
    fontWeight: 500,
    // fontFamily: "Dosis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  thickMenuDivider: {
    width: "100%",
    // backgroundColor:'#FFFFFF',
    marginTop: 21.5,
    borderBottom: "1px solid #666",
    opacity: 1,
  },
  menuDivider: {
    width: "100%",
    borderBottom: "1px solid #666",
    opacity: 0.3,
  },
}));

const activeLink = {
  color: 'var(--sidebar-bg) !important',
  fontWeight: 700,
  borderLeft: "8px solid var(--app-bar-bg)",
};

const FaqItem = ({ item, treeNode, onLeafClick }) => {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <MuiTreeView
        tree={[treeNode]}
        onLeafClick={onLeafClick}
        onParentClick={onLeafClick}
      />
      {hovered && item.description && (
        <div
          style={{
            backgroundColor: "#f0f4ff",
            border: "1px solid #c0d0f0",
            borderRadius: "6px",
            padding: "8px 12px",
            fontSize: "13px",
            color: "#333",
            lineHeight: "1.6",
            marginTop: "2px",
            marginBottom: "4px",
            marginLeft: "16px",
          }}
        >
          {item.description}
        </div>
      )}
    </div>
  );
};

// ---layout component---
export default function PersistentDrawerLeft(props) {
  let history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [footerStyle, setFooterStyle] = React.useState("footer-1");
  const [sitemapData, setSitemapData] = React.useState();
  const [isCaFirm, setIsCaFirm] = React.useState(false);
  const [quotaModalShow, setQuotaModalShow] = React.useState(false)
  const [quotaData, setQuotaData] = React.useState([])
  const [quotaLoading, setQuotaLoading] = React.useState(false)
  const [activeTab, setActiveTab] = React.useState('active')
  const [faqTree, setFaqTree] = React.useState([
    {
      id: 1,
      title: "How To - Connect Zoho Books Integration (Video)",
      file: 1,
      parent_id: 0,
      videoUrl:
      "https://storcicwsprod001.blob.core.windows.net/26as-assets/Zoho%20Books%20Integration%20Video.mp4",
      description:
        "Set up and connect your Zoho Books account to the 26AS module in just 2 minutes. Automatically sync customer records, invoices, and collections—quick and seamless.",
    },
    {
      id: 2,
      title: "How To - GSTR - 1 Filing",
      file: 1,
      parent_id: 0,
      videoUrl:
       "https://storcicwsprod001.blob.core.windows.net/gst-assets/GSTR-1%20Filing%20Video.mp4",
      description:
        "Learn how to selectively include, update, or exclude specific invoices and HSN details while filing your GSTR-1.",
    },
     {
          id: 3,
          title: "GSTR - 1 Selective Invoice Filing User Manual",
          file: 1,
          parent_id: 0,
          docUrl:
            "https://storcicwsprod001.blob.core.windows.net/gst-assets/GSTR-1%20Selective%20Invoice%20Filing%20-%20User%20Manual.docx",
          description:
            "Learn how to selectively include, update, or exclude specific invoices and HSN details, validate them, and submit your GSTR-1 filing directly to the GST Portal",
        },
    {
      id: 4,
      title: "26AS Module User Manual",
      file: 1,
      parent_id: 0,
      docUrl:
        "https://storcicwsprod001.blob.core.windows.net/26as-assets/26AS%20Reconciliation.docx",
      description:
        "Comprehensive user manual covering every feature of the 26AS module—from setup and data uploads to reconciliation, manual pairing, notifications, and more.",
    },
    {
      id: 5,
      title: " How To - Get Started with 26AS Reconciliation (Video)",
      file: 1,
      parent_id: 0,
      videoUrl:
      "https://storcicwsprod001.blob.core.windows.net/26as-assets/26AS%20Video%20Walkthrough.mp4",
      description:
        "Complete video walkthrough of the 26AS module—from login to final reconciliation. Learn how to set up, upload data, reconcile, and send customer notifications.",
    },

    {
      id: 6,
      title: "How To - Add Tally Connector (Video)",
      file: 1,
      parent_id: 0,
      videoUrl:
       "https://storcicwsprod001.blob.core.windows.net/tallyintegrations/Tally%20Connector%20Video.mp4",
      description:
        "Complete video walkthrough of the Tally Connector.",
    },
  ]);
  const [videoModalShow, setVideoModalShow] = React.useState(false);
  const [activeVideoUrl, setActiveVideoUrl] = React.useState("");
  const [videoLoading, setVideoLoading] = React.useState(false);
  const [faqModalShow, setFaqModalShow] = React.useState(false);
  const [logoUrl, setLogoUrl] = useState(null);

  React.useMemo(() => {
    setFooterStyle("footer-1");
  }, []);

  // const getFaqTree = () => {
  //   axios.get("faq").then((res) => {
  //     setFaqTree(res.data);
  //   });
  // };

  useEffect(() => {

    axios
      .get(
        `/cws_services/services_for_entity/${localStorage.getItem(
          "business_entity_id"
        )}`
      )
      .then((res) => {
        setSitemapData(res.data);

        // Reporting
        if (res.data.navigation_data["ARC DASHBOARD"]) {
          localStorage.setItem("showReport", "true");
        } else {
          localStorage.setItem("showReport", "false");
        }

        localStorage.setItem(
          "sitemap",
          JSON.stringify(res.data.navigation_data)
        );

        localStorage.setItem("arcUploadSale", res?.data?.arcUploadSale)
        localStorage.setItem("arcUploadPurchase", res?.data?.arcUploadPurchase)
        localStorage.setItem("employee_details", res?.data?.employee_details ? "true" : "false");
        localStorage.setItem("tds_transaction_details", res?.data?.tds_transaction_details ? "true" : "false");
        localStorage.setItem("nri_details", res?.data?.nri_details ? "true" : "false");
        localStorage.setItem("service_privileges", JSON.stringify(res?.data?.service_privileges || {}));

        localStorage.setItem(
          "daybook",
          res?.data?.navigation_data?.["ARC RECONCILLIATION"]?.["DAY BOOK"]
            ? "true"
            : "false"
        );

        localStorage.setItem(
          "coa",
          res?.data?.navigation_data?.["ARC RECONCILLIATION"]?.["CHART OF ACCOUNTS"]
            ? "true"
            : "false"
        );
        //  localStorage.setItem(
        //   "employee_details",
        //   res?.data?.navigation_data?.["ARC RECONCILLIATION"]?.["Employee Details"]
        //     ? "true"
        //     : "false"
        // );
        //  localStorage.setItem(
        //   "tds_transaction_details",
        //   res?.data?.navigation_data?.["ARC RECONCILLIATION"]?.["TDS Transaction Details"]
        //     ? "true"
        //     : "false"
        // );
      })
      .catch((error) => { });
    // getFaqTree();
  }, []);

  const menuId = "primary-search-account-menu";

  // ---Logout funtion---
  const logout = () => {
    const userid = localStorage.getItem("user_id")
    axios
      .get(`/logout/${userid}`)
      .then((res) => {
        localStorage.clear();

        history.push("/login");
      })
      .catch((error) => {
        console.log(error);
        toast.error(error?.response?.data?.message, {
          autoClose: 3000,
          progress: 0,
        });
      });
  };



  // Change this:
  useEffect(() => {
    getLogo();
    window.addEventListener('logoUpdated', getLogo);
    return () => {
      window.removeEventListener('logoUpdated', getLogo);
    };
  }, []);

  // To this:
  const getLogo = () => {
    axios.get(`get_customer_logo/${localStorage.getItem("business_entity_id")}/${false}`)
      .then((res) => {
        if (res.data.status && res.data.logo_url) {
          setLogoUrl(res.data.logo_url + '?t=' + Date.now()); // cache bust
        } else {
          setLogoUrl(cws_logo);
        }
      })
      .catch((err) => {
        setLogoUrl(cws_logo);
      });
  };

  useEffect(() => {
    getLogo();
    window.addEventListener('logoUpdated', getLogo);
    return () => {
      window.removeEventListener('logoUpdated', getLogo);
    };
  }, []);

  // ---Handle profile function---
  const handleProfile = (props) => {
    history.push("/personalProfile");
  };

  const handleCheckQuotaUsage = () => {
    const caFirmFlag = localStorage.getItem("is_ca_firm") === "true";
    if (!caFirmFlag) return;
    const businessEntityId = localStorage.getItem("business_entity_id");
    setQuotaModalShow(true);
    setQuotaLoading(true);
    setActiveTab('active');
    axios
      .get(`/get_active_quotas/${businessEntityId}`)
      .then((res) => {
        setQuotaData(res.data?.records || []);
      })
      .catch(() => {
        toast.error("Failed to load quota data.", { autoClose: 3000 });
      })
      .finally(() => setQuotaLoading(false));
  };


  // ---Handle home function--
  const handleHomeButton = () => {
    localStorage.removeItem("PanNumber");
    localStorage.removeItem("business_entity_id");
    localStorage.removeItem("entity_name");
    localStorage.removeItem("gst");
    localStorage.removeItem("Client_ID");
    localStorage.setItem("TriggerPanDashBoard", "false");
    localStorage.removeItem("Trigger_Effitrac/Tally_Button");
    history.push("/home");
  };


  const recursion = (first_tree, original_tree) =>
    first_tree.map((v, i) => {
      let parent_id = v.id;
      const inside_tree = original_tree.filter(
        (v) => v.parent_id === parent_id
      );
      if (inside_tree.length) {
        const node = {
          value: v.title,
          id: v.id,
          file: v.file,
          nodes: recursion(inside_tree, original_tree),
        };
        console.log("inside");
        return node;
      } else {
        return {
          value: v.title,
          id: v.id,
          file: v.file,
          nodes: [],
        };
      }
    });


  const downloadPdf = (faq_id, file_name) => {
    axios.get(`download_faq/${faq_id}`).then((res) => {
      downloadBase64File(res.data.file, file_name);
    });
  };


  const downloadBase64File = (base64Data, fileName) => {
    const linkSource = `data:application/pdf;base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  // Fetches the whole video into memory and plays it from a local blob: URL.
  // Azure Blob Storage isn't honoring Range requests for this account
  // (it returns 200 with the whole file instead of 206 Partial Content),
  // so seeking/fast-forwarding was unreliable when streamed directly from
  // the blob URL. Once the full video is in a local blob, the browser
  // seeks within data it already has in memory and no longer depends on
  // Azure's Range support at all.
  const openVideo = async (videoUrl) => {
    try {
      setVideoLoading(true);
      setVideoModalShow(true);
      const response = await fetch(videoUrl);
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      setActiveVideoUrl(blobUrl);
    } catch (err) {
      console.error("Video load failed:", err);
      toast.error("Sorry, the video could not be loaded. Please try again.", {
        autoClose: 3000,
      });
      setVideoModalShow(false);
    } finally {
      setVideoLoading(false);
    }
  };

  const closeVideoModal = () => {
    // Release the memory held by the blob URL once we're done with it
    if (activeVideoUrl) {
      window.URL.revokeObjectURL(activeVideoUrl);
    }
    setVideoModalShow(false);
    setActiveVideoUrl("");
  };

  const VideoModal = () => {
    return (
      <Modal
        show={videoModalShow}
        onHide={closeVideoModal}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Video Guide</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, background: "#000", minHeight: videoLoading ? "300px" : "auto" }}>
          {videoLoading ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "300px", color: "#fff" }}>
              <CircularProgress style={{ color: "#fff", marginBottom: "12px" }} />
              <span>Loading video…</span>
            </div>
          ) : (
            activeVideoUrl && (
              <video
                key={activeVideoUrl}
                width="100%"
                height="500px"
                controls
                autoPlay
                style={{ display: "block" }}
              >
                <source src={activeVideoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ color: "red" }}
            onClick={closeVideoModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const FaqModal = (props) => {
    let first_tree = props.tree.filter((v) => v.parent_id === 0);
    let original_tree = recursion(first_tree, props.tree);

    const handleLeafClick = (node) => {
      const originalItem = props.tree.find((v) => v.id === node.id);
      if (originalItem?.videoUrl) {
        openVideo(originalItem.videoUrl);
      } else if (originalItem?.docUrl) {
        const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(originalItem.docUrl)}&embedded=false`;
        window.open(googleViewerUrl, "_blank");
      } else if (node.file) {
        downloadPdf(node.id, node.value);
      }
    };

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Cappitall Want Solutions (CWS) FAQs?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.tree
            .filter((item) => item.parent_id === 0)
            .map((item) => {
              const treeNode = original_tree.find((n) => n.id === item.id);
              if (!treeNode) return null;
              return (
                <FaqItem
                  key={item.id}
                  item={item}
                  treeNode={treeNode}
                  onLeafClick={handleLeafClick}
                />
              );
            })}
        </Modal.Body>
        <Modal.Footer>
          <Button style={{ color: "red" }} onClick={props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const QuotaModal = () => {
    const tabs = ['active', 'expired', 'upcoming']
    const tabColors = {
      active: '#27ae60',
      expired: '#c0392b',
      upcoming: '#e67e22',
    }
    const filteredData = quotaData.filter(q => q.quota_status === activeTab)

    return (
      <Modal
        show={quotaModalShow}
        onHide={() => setQuotaModalShow(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: '#17375e' }}>
          <Modal.Title style={{ color: '#fff', fontSize: '18px', fontWeight: 600 }}>
            Quota Usage
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px' }}>
          {/* Filter Tabs */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            {tabs.map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: '5px 18px',
                  borderRadius: '20px',
                  border: `1.5px solid ${tabColors[tab]}`,
                  backgroundColor: activeTab === tab ? tabColors[tab] : 'transparent',
                  color: activeTab === tab ? '#fff' : tabColors[tab],
                  fontWeight: 600,
                  fontSize: '13px',
                  cursor: 'pointer',
                  textTransform: 'capitalize',
                }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          {quotaLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
              <CircularProgress size={32} />
            </div>
          ) : filteredData.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#888' }}>No {activeTab} quotas found.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', maxHeight: '360px', overflowY: 'auto', paddingRight: '4px' }}>
              {filteredData.map((quota) => {
                const usedPct = quota.quota_limit > 0
                  ? Math.round((quota.used / quota.quota_limit) * 100)
                  : 0
                const barColor = usedPct >= 90 ? '#e74c3c' : usedPct >= 60 ? '#f39c12' : '#27ae60'
                return (
                  <div
                    key={quota.id}
                    style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      padding: '16px',
                      backgroundColor: '#f9f9f9'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <div>
                        <span style={{
                          fontSize: '11px', fontWeight: 700, textTransform: 'uppercase',
                          color: '#17375e', backgroundColor: '#e8eef5',
                          padding: '2px 8px', borderRadius: '4px', letterSpacing: '0.5px'
                        }}>
                          {quota.scope_type}
                        </span>
                        {quota.scope_value && (
                          <span style={{ marginLeft: '8px', fontSize: '13px', color: '#555' }}>
                            — {quota.scope_value}
                          </span>
                        )}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                        <span style={{ fontSize: '12px', color: '#888' }}>
                          {quota.effective_from} → {quota.effective_to}
                        </span>
                        {quota.period_type && quota.period_value && (
                          <span style={{ fontSize: '12px', color: '#888' }}>
                            {quota.period_type.replace(/_/g, ' ').toUpperCase()} → {quota.period_value}
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ height: '8px', backgroundColor: '#e0e0e0', borderRadius: '4px', overflow: 'hidden', marginBottom: '8px' }}>
                      <div style={{ width: `${Math.min(usedPct, 100)}%`, height: '100%', backgroundColor: barColor, borderRadius: '4px', transition: 'width 0.4s ease' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                      <span style={{ color: '#555' }}>Used: <strong style={{ color: barColor }}>{quota.used.toLocaleString()}</strong></span>
                      <span style={{ color: '#555' }}>Remaining: <strong style={{ color: '#27ae60' }}>{quota.remaining.toLocaleString()}</strong></span>
                      <span style={{ color: '#555' }}>Limit: <strong style={{ color: '#17375e' }}>{quota.quota_limit.toLocaleString()}</strong></span>
                      <span style={{ color: '#555' }}><strong style={{ color: barColor }}>{usedPct}%</strong> used</span>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button style={{ color: 'red' }} onClick={() => setQuotaModalShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  // const getDefaultUploadsPath = () => {
  //   // Read from state/API response, not localStorage
  //   const arcUploadSale = sitemapData?.arcUploadSale;
  //   const arcUploadPurchase = sitemapData?.arcUploadPurchase;
  //   const employeeDetails = sitemapData?.employee_details;
  //   const tdsTransactionDetails = sitemapData?.tds_transaction_details;
  // const nriDetails = sitemapData?.nri_details;

  //   const options = [
  //     arcUploadSale && '/BusinessCustomerManagement',
  //     arcUploadSale && '/InvoiceManagement',
  //     arcUploadSale && '/uploadCollectionsData',
  //     arcUploadSale && '/uploadPaymentAdviceData',

  //     arcUploadPurchase && '/vendorManagement',
  //     arcUploadPurchase && '/PurchaseInvoiceMgmt',
  //     arcUploadPurchase && '/vendorCollections',
  //     arcUploadPurchase && '/VendorpaymentAdvice',


  //     // arcUploadDaybook && '/zoho',
  //     // arcUploadDaybook && '/tally',


  //     // arcUploadCOA && '/coa',

  //     employeeDetails && '/employeeDetails',
  //     tdsTransactionDetails && '/tdsTransactionDetails'

  //   ].filter(Boolean);

  //   return options[0] || null;
  // };

  const getDefaultUploadsPath = () => {
    const arcUploadSale = sitemapData?.arcUploadSale;
    const arcUploadPurchase = sitemapData?.arcUploadPurchase;
    const employeeDetails = sitemapData?.employee_details;
    const tdsTransactionDetails = sitemapData?.tds_transaction_details;

    const hasAnyAccess = arcUploadSale || arcUploadPurchase ||
      employeeDetails || tdsTransactionDetails;

    return hasAnyAccess ? '/Data-Upload' : null;
  };

  const getDefaultValidationPath = () => {
    const salesAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const options = [
      salesAccess.includes("GSTR1-PREVALIDATION") && '/gstPreValidation',
      purchaseAccess.includes("GSTR2-PREVALIDATION") && '/Gstr2bPrevalidation',
      sitemapData?.["GSTIN & PAN VALIDATION"] && '/GstrPanValidation'
    ].filter(Boolean);

    return options[0] || null;
  };

  const getDefaultFilingPath = () => {
    const salesAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const hasAnyAccess =
      salesAccess.includes("FILLING") ||
      purchaseAccess.includes("24Q FILLING (Form-138)") ||
      purchaseAccess.includes("26Q FILLING (Form-140)");

    return hasAnyAccess ? '/Filing' : null;
  };

  const getDefaultRepoPath = () => {

    const salesAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.PURCHASE || [];
    const allThreeRepoAvailable =
      salesAccess.includes("GSTR1-REPOSITORY") ||
      purchaseAccess.includes("GSTR2A-REPOSITORY") ||
      purchaseAccess.includes("GSTR2B-REPOSITORY");

    // TDS Challan: requires TDS PAYABLE RECONCILLATION + at least one filing type
    const tdsChallanAccess = purchaseAccess.includes("TDS PAYABLE RECONCILLATION");
    const tdsChallanEnabled =
      tdsChallanAccess && (
        purchaseAccess.includes("26Q FILLING (Form-140)") ||
        purchaseAccess.includes("24Q FILLING (Form-138)") ||
        purchaseAccess.includes("27Q FILING (Form-144)")
      );

    const options = [
      '/repoCards',
      allThreeRepoAvailable && '/GSTRepositoryMain',
      salesAccess.includes("GSTR1-REPOSITORY") && '/GSTRepo',
      salesAccess.includes("GSTR1-RECONCILLATION") && '/GSTR1ARepo',
      purchaseAccess.includes("GSTR2A-REPOSITORY") && '/Gst2aRepository',
      purchaseAccess.includes("GSTR2B-REPOSITORY") && '/Gstr2bRepository',
      purchaseAccess.includes("GSTR3B") && '/GSTR_3B_Repository',
      sitemapData?.navigation_data?.["GSTR-9 RECONCILIATION"]?.['GSTR-9']?.includes("GSTR-9 RECONCILIATION") && '/Gstr8aRepository',
      purchaseAccess.includes("GSTR2-PREVALIDATION") && '/Gst2aStaus',
      salesAccess.includes("E-INVOICE RECONCILIATION") && '/E-InvoiceRepo',
      purchaseAccess.includes("IMS-REPOSITORY") && '/IMSRepo',
      salesAccess.includes("IMS OUTWARD REPOSITORY") && '/IMSRepoOutward',
      (salesAccess.includes("26AS-TDS-REPOSITORY") && localStorage.getItem("show_recon") !== "N") && '/TDSRepo',
      purchaseAccess.includes("AIS REPOSITORY") && '/AisUpload',
      tdsChallanEnabled && '/TDSChallanRepository',  // ← updated
    ].filter(Boolean);

    return options[0] || null;
  };

  const getDefaultReconPath = () => {

    const salesAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.PURCHASE || [];
    const allThreeReconAvailable =
      salesAccess.includes("GSTR1-RECONCILLATION") ||
      purchaseAccess.includes("GSTR2A-RECONCILLATION") ||
      purchaseAccess.includes("GSTR2B-RECONCILLATION");

    const options = [
      '/reconCards',
      allThreeReconAvailable && '/IntegratedGSTReconciliation',
      salesAccess.includes("GSTR1-RECONCILLATION") && '/GSTReconciliation',
      purchaseAccess.includes("GSTR2A-RECONCILLATION") && '/Gst2aReconciliation',
      purchaseAccess.includes("GSTR2B-RECONCILLATION") && '/Gstr2bReconciliation',
      purchaseAccess.includes("GSTR3B") && '/GSTR_3B_Reconciliation',
      purchaseAccess.includes("IMS-RECONCILIATION") && '/IMSReconciliation',
      sitemapData?.navigation_data?.["GSTR-9 RECONCILIATION"]?.['GSTR-9']?.includes("GSTR-9 RECONCILIATION") && '/Gstr8aReconciliation',
      sitemapData?.navigation_data?.["GSTR-9 RECONCILIATION"]?.['GSTR-9']?.includes("GSTR-9 RECONCILIATION") && '/GSTR_9Reconciliation',
      salesAccess.includes("E-INVOICE RECONCILIATION") && '/e_invoicereconcilation',
      (salesAccess.includes("TDS RECIEVABLE RECON") && localStorage.getItem("show_recon") !== "N") && '/26ASRecon',
      (salesAccess.includes("TDS RECIEVABLE RECON") && localStorage.getItem("show_recon") !== "N") && '/TCS/Recon/26AS',
      purchaseAccess.includes("26Q FILLING") && '/TDSProvision',
      purchaseAccess.includes("26Q FILLING") && '/Gst2aTdsReconciliation',
      purchaseAccess.includes("AIS REPOSITORY") && '/AisDashboard'
    ].filter(Boolean);

    return options[0] || null;
  };

  const getDefaultReportPath = () => {

    const wrokingCapitalAccess = sitemapData?.navigation_data?.["REPORT ANALYTICS"]?.['WORKING CAPITAL'] || [];
    const statutoryComplianceAccess = sitemapData?.navigation_data?.["REPORT ANALYTICS"]?.['STATUTORY COMPLIANCE'] || [];
    const purchaseAccess = sitemapData?.navigation_data?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const options = [
      '/reportCards',
      wrokingCapitalAccess?.includes("ITEM WISE REPORT") && '/itemWiseReportHsn',
      wrokingCapitalAccess?.includes("AGEING REPORT") && '/ageing_recivable_report_dashboard',
      wrokingCapitalAccess?.includes("AGEING REPORT") && '/ageing_payable_report_dashboard',
      wrokingCapitalAccess?.includes("C2C REPORT") && '/C2CReportDashboard',

      statutoryComplianceAccess?.includes("ITC AVAILABILITY REPORT") && '/itcAvailReportBooks',
      statutoryComplianceAccess?.includes("ITC REVERSAL REPORT") && '/itcRevarsalReport',
      statutoryComplianceAccess?.includes("VENDOR CANCELLATION REPORT") && '/VendorCancellation',
      statutoryComplianceAccess?.includes("MULTIMONTH REPORT") && '/MultiMonth',
      statutoryComplianceAccess?.includes("HSN SUMMARY REPORT") && '/HsnSummaryReport',
      statutoryComplianceAccess?.includes("GST INWARD COMPARISON") && '/Inward_comparison',
      statutoryComplianceAccess?.includes("GST OUTWARD COMPARISON") && '/Outward_comparison',
      statutoryComplianceAccess?.includes("GST COMPUTATION REPORT") && '/gst_computation_report',
      statutoryComplianceAccess?.includes("RCM REPORT") && '/RcmSummary',
      statutoryComplianceAccess?.includes("GST LEDGERS") && '/GstLedgers',
      purchaseAccess?.includes("FORM 16/16A") && '/Form16',
      statutoryComplianceAccess?.includes("TDS APPLICABILITY REPORT") && '/tdsApplicabilityReport',
      statutoryComplianceAccess?.includes("ITC/RCM ELIGIBLITY REPORT") && '/rcmReport',
    ].filter(Boolean);

    return options[0] || null;
  };

  const handleBusinessInfoClick = (e) => {
    e.preventDefault();
    const businessEntityId = localStorage.getItem("business_entity_id");
    axios
      .get(`/check_if_ca_firm_or_not/${businessEntityId}`)
      .then((res) => {
        localStorage.setItem("is_ca_firm", res.data?.is_ca_firm === true ? "true" : "false");
        history.push("/BusinessEntityDetails");
      })
      .catch((error) => {
        console.log(error);
        toast.error(error?.response?.data?.message, {
          autoClose: 3000,
          progress: 0,
        });
      });
  };

  const sidebarMenuOptions = [
    {
      title: "Info & Setup",
      toolTip: 'Info & Setup',
      icon: <BusinessIcon size="medium" />,
      link: "/BusinessEntityDetails",
      activePaths: [
        '/BusinessEntityDetails'
      ],
      isServiceEnabled: true,
      onClick: handleBusinessInfoClick
    },
    {
      title: "Uploads",
      toolTip: 'Uploads',
      icon: <IosShareIcon size="medium" />,
      link: getDefaultUploadsPath(),
      activePaths: [
        '/Data-Upload',
        '/BusinessCustomerManagement',
        '/InvoiceManagement',
        '/uploadCollectionsData',
        '/uploadPaymentAdviceData',
        '/vendorManagement',
        '/PurchaseInvoiceMgmt',
        '/vendorCollections',
        '/VendorpaymentAdvice',
        '/zoho',
        '/tally',
        '/coa',
        '/employeeDetails',
        '/tdsTransactionDetails',
        '/nriDetails',

      ],
      isServiceEnabled: getDefaultUploadsPath() !== null,
    },
    {
      title: "Validation",
      toolTip: 'Data Validation',
      icon: <FactCheckIcon size="medium" />,
      link: getDefaultValidationPath(),
      activePaths: [
        '/Data-Validation',
        '/gstPreValidation',
        '/Gstr2bPrevalidation',
        '/GstrPanValidation'
      ],
      isServiceEnabled: getDefaultValidationPath() !== null,
    },
    {
      title: "Filing",
      toolTip: 'Filing',
      icon: <AssessmentIcon size="medium" />,
      link: getDefaultFilingPath(),
      activePaths: [
        '/Filing',
        '/Reporting',
        '/24QFiling',
        '/26QFiling',
        '27QFiling'
      ],
      isServiceEnabled: getDefaultFilingPath() !== null
    },
    {
      title: "Repository",
      toolTip: 'Repository',
      icon: <FolderOpenIcon size="medium" />,
      link: getDefaultRepoPath(),
      activePaths: [
        '/repoCards'
        // '/GSTRepositoryMain',
        // '/Repository',
        // '/GSTRepo',
        // '/GSTR1ARepo',
        // '/Gst2aRepository',
        // '/Gstr2bRepository',
        // '/GSTR_3B_Repository',
        // '/Gstr8aRepository',
        // '/TDSRepo',
        // '/AisUpload',
        // '/E-InvoiceRepo',
        // '/Gst2aStaus',
        // '/IMSRepo',
        // '/IMSRepoOutward',
        // '/TDSChallanRepository',
        // '/TdsChallanAssociate'
      ],
      isServiceEnabled: getDefaultRepoPath() !== null,
    },
    {
      title: "Recon",
      toolTip: 'Reconcillitation',
      icon: <TaskIcon size="medium" />,
      link: getDefaultReconPath(),
      activePaths: [
        '/reconCards',
        // '/Recon',
        // '/IntegratedGSTReconciliation',
        // '/GSTReconciliation',
        // '/Gst2aReconciliation',
        // '/Gstr2bReconciliation',
        // '/Gstr8aReconciliation',
        // '/GSTR_9Reconciliation',
        // '/e_invoicereconcilation',
        // '/26ASRecon',
        // '/TCS/Recon/26AS',
        // '/Gst2aTdsReconciliation',
        // '/AisDashboard',
        // '/gstReconUpdatedTabDetails',
        // '/gst2aReconReport',
        // '/gstr2bReconciliationReport',
        // '/gstr8aReconciliationReport',
        // '/GSTR9-ReportingPage',
        // '/E_Invoice_Details',
        // '/26ASReport',
        // '/26ASExcelParing',
        // '/26Pairing',
        // '/TCS/Report/26AS',
        // '/TCS/Pairing/26AS',
        // '/aisviewdata',
        // '/TDSProvision',
        // '/IMSReconciliation',
        // '/TdsLiabilities',
        // '/TdsPayableDashboard'
      ],
      isServiceEnabled: getDefaultReconPath() !== null,
    },
    {
      title: "Reports",
      toolTip: 'Reporting & Analytics',
      icon: <DonutSmallIcon size="medium" />,
      link: getDefaultReportPath(),
      activePaths: [
        // '/Reports',
        '/reportCards',
        // '/itemWiseReportHsn',
        // '/itemWiseReportContainer',
        // '/ageing_recivable_report_dashboard',
        // '/ageing_payable_report_dashboard',
        // '/C2CReportDashboard',
        // '/itcAvailReportBooks',
        // '/sectionReport',
        // '/itcRevarsalReport',
        // '/VendorCancellation',
        // '/MultiMonth',
        // '/HsnSummaryReport',
        // '/HsnSummaryDetails',
        // '/Inward_comparison',
        // '/Outward_comparison',
        // '/gst_computation_report',
        // '/RcmSummary',
        // '/GstLedgers',
        // '/Form16',
        // '/tdsApplicabilityReport'
        // '/rcmReport',
      ],
      isServiceEnabled: getDefaultReportPath() !== null,
    },
    {
      title: "IARS",
      toolTip: 'IARS',
      icon: <DashboardIcon size="medium" />,
      link: "/iarsloginDashboard",
      activePaths: [
        '/iarsloginDashboard',
        '/iarsexecutivesummary',
        '/iarsreasonwise',
        '/damagestocksummary'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.IARS,
    },
    {
      title: "E-INVOICE",
      toolTip: 'E-INVOICE',
      icon: <DescriptionIcon size="medium" />,
      link: "/einvoice",
      activePaths: [
        '/einvoice',
        '/ArcEinvoice',
        '/EinvoicePreValidation',
        '/Summary',
        '/EinvoiceDashBoard'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.EINVOICE,
    },
    {
      title: "Credit",
      toolTip: 'Credit Evaluation',
      icon: <CreditCardIcon size="medium" />,
      link: "/dashboardCreditEvalution",
      activePaths: [
        '/dashboardCreditEvalution'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.["CREDIT EVALUATION"],
    },
    {
      title: "Upload Tally",
      toolTip: 'Upload Tally File',
      icon: <IosShareIcon size="medium" />,
      link: "/UploadTallyBackUpFile",
      activePaths: [
        '/UploadTallyBackUpFile'
      ],
      isServiceEnabled: localStorage.getItem("UploadTallyStatus") === "true",
    },

    {
      title: (
        <>
          Compliance
          <br />
          Monitor
        </>
      ),
      toolTip: 'Compliance Monitor',
      icon: <BusinessIcon size="medium" />,
      link: "/ComplianceMonitor",
      activePaths: [
        '/ComplianceMonitor'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.["COMPLIANCE MONITOR"],
    },
    {
      title: (
        <>
          Notice
          <br />
          Management
        </>
      ),
      toolTip: 'Notice Management',
      icon: <NoteIcon size="medium" />,
      link: "/NoticeManagement",
      activePaths: [
        '/NoticeManagement'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.["NOTICE MANAGEMENT"],
    },
    {
      title: "MDM",
      toolTip: 'Master Data Maintenance (MDM)',
      icon: <WorkIcon size="medium" />,
      link: "/mdm",
      activePaths: [
        '/mdm'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.["MASTER DATA MAINTAINANCE [MDM]"],
    },
    {
      title: "MSME",
      toolTip: 'MSME',
      icon: <HandshakeIcon size="small" />,
      link: "/msme-page",
      activePaths: [
        '/msme-page'
      ],
      isServiceEnabled: sitemapData?.navigation_data?.["MSME"],
    },
  ]

  return (
    <div className={classes.root} >
      <CssBaseline />

      {/* ---APPBAR--- */}
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
        style={{ background: "var(--app-bar-bg)" }}
      >
        <Toolbar>
          <Tooltip title="Profile">
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfile}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </Tooltip>

          <p
            style={{ paddingLeft: "10px", paddingTop: "2px", fontSize: "16px" }}
          >
            {localStorage.getItem("user_name")}
          </p>

          <div style={{ marginLeft: "auto", textTransform: "capitalize", display: 'flex', alignItems: 'center' }}>

            {/* Check Quota Usage Button — visible only if is_ca_firm */}
            {localStorage.getItem("is_ca_firm") === "true" && (
              <Tooltip title="Check Quota Usage">
                <Button
                  onClick={handleCheckQuotaUsage}
                  style={{
                    color: '#fff',
                    border: '1px solid rgba(255,255,255,0.6)',
                    borderRadius: '6px',
                    textTransform: 'none',
                    fontSize: '13px',
                    fontWeight: 600,
                    padding: '4px 14px',
                    marginRight: '10px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Check Quota Usage
                </Button>
              </Tooltip>
            )}

            <Tooltip title="FAQ">
              <IconButton
                edge="end"
                aria-label="FAQ"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={() => setFaqModalShow(true)}
                color="inherit"
              >
                <ContactSupportIcon />
              </IconButton>
            </Tooltip>
            {window.location.pathname !== "/home" ? (
              <Tooltip title="Home">
                <IconButton
                  edge="end"
                  aria-label="home"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleHomeButton}
                  color="inherit"
                >
                  <HomeIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}

            <Tooltip title="Logout">
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={logout}
                color="inherit"
              >
                <ExitToAppIcon style={{ color: "#FFF" }} />
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
        {/* SUB HEADER */}
        <div
          style={{
            borderTop: "1px solid #fff",
            padding: "10px 25px",
            fontSize: "18px",
            fontFamily: "Dosis",
            fontWeight: "600",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>ENTITY NAME: </span>
            <span style={{ fontSize: "16px" }}>{localStorage.getItem("entity_name")}</span>
          </div>

          <div>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>GSTIN / PAN: </span>
            <span style={{ fontSize: "16px" }}>{localStorage.getItem("entity_type") === "Group" ? localStorage.getItem("gst")?.slice(-10) : localStorage.getItem("gst")}</span>
          </div>

          <div>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>ENTITY TYPE: </span>
            <span style={{ fontSize: "16px" }}>{localStorage.getItem("entity_type")}</span>
          </div>

          <div>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>BRANCH NAME: </span>
            <span style={{ fontSize: "16px" }}>{localStorage.getItem("branch_name")}</span>
          </div>
        </div>

      </AppBar>

      {/* SIDE BAR--- */}
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {/* ---Drawer header--- */}
        <Box className={classes.logoBox} onClick={handleHomeButton}>
          {/* <img src={cws_logo} alt="Logo" className={classes.logo} /> */}
          <img src={logoUrl || cws_logo} className={classes.logo} />
        </Box>

        {/* MENUS */}
        <div className="sidebar">
          {localStorage.getItem("TriggerPanDashBoard") === "true" ? (
            <div className="sidebarMenus">
              <PanDashBoard />
            </div>
          ) : (
            <>
              <div className={classes.thickMenuDivider} />
              <div className="sidebarMenus">

                <List style={{ padding: "0px" }}>



                  {/* Services */}
                  {
                    sidebarMenuOptions.map((item, index) => {
                      const {
                        title,
                        toolTip,
                        icon,
                        link,
                        activePaths,
                        isServiceEnabled
                      } = item;

                      return (
                        isServiceEnabled && (
                          <React.Fragment key={index}>
                            <Tooltip title={toolTip} placement="right">
                              <ListItem
                                button
                                component={item.onClick ? "div" : NavLink}
                                to={item.onClick ? undefined : link}
                                activeStyle={item.onClick ? undefined : activeLink}
                                isActive={
                                  item.onClick
                                    ? undefined
                                    : (match, location) =>
                                      activePaths?.some(path =>
                                        location.pathname.startsWith(path)
                                      )
                                }
                                className={classes.listItem}
                                onClick={item.onClick || undefined}
                                style={
                                  item.onClick &&
                                    window.location.pathname.startsWith('/BusinessEntityDetails')
                                    ? activeLink
                                    : {}
                                }
                              >
                                <ListItemIcon className={classes.listItemIcon}>
                                  {icon}
                                </ListItemIcon>

                                <ListItemText
                                  primary={title}
                                  classes={{ primary: classes.listItemText }}
                                />
                              </ListItem>
                            </Tooltip>

                            <div className={classes.menuDivider} />
                          </React.Fragment>
                        )
                      );
                    })
                  }
                </List>
              </div>
            </>
          )}
        </div>
      </Drawer>

      {/*---main content of dashboards start---*/}
      <main
        style={{ overflowX: 'auto' }}
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeaderSpace} />
        <div style={{ marginBottom: "30px" }}>{props.children}</div>

        {/* FOOTER */}
        <footer className={footerStyle}>
          <div className="left">
            For support , please contact{" "}
            <a
              target="_self"
              href='mailto:support@cappitallwant.com'
              style={{ color: 'var(--app-bar-bg)', fontWeight: "600" }}
            >
              support@cappitallwant.com
            </a>
          </div>
          <div className="right">
            Powered by CWS&#8482; |{" "}
            <a
              href="https://www.cappitallwant.com/terms-and-conditions/"
              target="_blank"
              style={{ color: "var(--app-bar-bg)" }}
              rel="noreferrer"
            >
              {" "}
              Terms of use
            </a>{" "}
            |{" "}
            <a
              href="https://www.cappitallwant.com/privacy-policy/"
              target="_blank"
              style={{ color: "var(--app-bar-bg)" }}
              rel="noreferrer"
            >
              {" "}
              Privacy Policy
            </a>
          </div>
        </footer>
      </main>

      <FaqModal
        show={faqModalShow}
        onHide={() => setFaqModalShow(false)}
        tree={faqTree}
      />
      <VideoModal />
      <QuotaModal />
    </div>
  );
}

